<template>
    <div class="entity-info-card-container">
        <header>
            <div class="header_left">

            </div>
            <div class="header_right">
                <div class="header">{{ header }}</div>
            </div>
        </header>
        <div class="entity-detail-container">
            <h4 class="name">{{ entityName }}</h4>
            <div class="div-table">
                <div
                    v-for="(item, idx) in orderedItems"
                    :key="`entity-info-card-item-${idx}`"
                    class="div-table-row">
                    <div class="div-table-col-key">{{ $t(`${item.name}`) }}:</div>
                    <div class="div-table-col-value">{{ item.value ?? itemValue(item.key) }}</div>
                </div>
            </div>

            <button
                v-if="actionAllow"
                class="btn"
                @click.prevent="onAction">
                <div class="btn-wrapper">
                    <i :class="['icon', btnIcon]"></i>
                    <p class="text-icon">{{ actionTxt }}</p>
                </div>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        mixins: [
        ],
        props: {
            value: {
                type: Object,
                default: () => {
                    return {};
                },
            },
            headerText: {
                type: String,
                default: null,
            },
            btnIcon: {
                type: String,
                default: 'far fa-user', //far fa-rectangle-list
            },
            btnText: {
                type: String,
                default: null,
            },
            btnAllow: {
                type: Boolean,
                default: false,
            },
            baseTranslateID: {
                type: String,
                default: 'entities',
            },
            extraInfo: {
                type: Array,
                default: () => {return [];},
            },
        },
        data() {
            return {
            }
        },
        computed: {
            items() {
                return [
                    ...[
                        {key: 'phone', name: `${this.modelTranslateID}.phone`, order: 10},
                        {key: 'email', name: `${this.modelTranslateID}.email`, order: 11},
                        {key: 'full_address', name: `${this.modelTranslateID}.address`, order: 12},
                        // {key: 'occupation', name: 'occupation', order: 1},
                        // {key: 'birth_at', name: 'birth_at', order: 1},
                        // {key: 'death_at', name: 'death_at', order: 1},
                    ],
                    ...this.extraInfo
                ];
            },
            orderedItems(){
                return this.items.sort((a,b) => a.order - b.order);
            },
            translateID() {
                return `${this.baseTranslateID}`
            },
            modelTranslateID() {
                return `${this.translateID}.model`
            },
            entity() {
                return this.value ?? {};
            },
            entityName() {
                return this.entity?.name;
            },
            header() {
                return this.$t(this.headerText);
            },
            actionTxt() {
                return this.$t(this.btnText ?? `${this.translateID}.buttons.details`);
            },
            actionAllow() {
                return this.btnAllow;
            }
        },
        methods: {
            itemValue(key) {
                return this.entity[key] ?? null;
            },
            onAction(evt) {
                if(this.actionAllow) {
                    this.$emit('action', this.entity)
                }
            }
        },
        // watch: {
        //     value: {
        //         deep: true,
        //         immediate: true,
        //         handler: function(value, oldValue){
        //             console.log('VALUE ENTITY INFO CARD, value')
        //             this.form = value;
        //         }
        //     },
        //     form: {
        //         deep: true,
        //         handler: function(value, oldValue){
        //             this.$emit('input', value);
        //         }
        //     },
        // }
    }
</script>

<style lang="scss" scoped>
.entity-info-card-container {
    display: block;
    width: 100%;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    word-break: break-word;

    header {
        display: flex;
        justify-content: space-between;

        .header_left {
            display: flex;
            align-items: center;
        }
        .header_right {
            display: flex;
            align-items: center;
        }

        .header {
            letter-spacing: normal;
            margin: 0 0 16px;
            font-family: var(--city-font-family);
            font-size: 16px;
            font-weight: 600;
            line-height: 1;
            color: var(--primary-color);
        }
    }
    .entity-detail-container {
        .name {
            letter-spacing: normal;
            margin: 0 0 16px;
            font-size: 20px;
            line-height: 30px;
            text-transform: none;
        }

        .div-table {
            width: 100%;
            display: table;
            font-size: 16px;
            line-height: 24px;

            .div-table-row {
                width: auto;
                display: table-row;

                .div-table-col-key {
                    opacity: .6;
                    padding-bottom: 8px;
                    padding-right: 10px;
                    white-space: nowrap;
                    display: table-cell;
                }

                .div-table-col-value {
                    padding-bottom: 8px;
                    display: table-cell;
                }
            }
        }

        .btn {
            margin: 8px 0 0;
            padding: 0 15px;
            line-height: 34px;
            width: 100%;
            height: 40px;
            border: 1px solid rgba(0, 0, 0, .12);
            font-size: 16px;
            color: var(--primary-color);

            .btn-wrapper {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                -webkit-box-pack: center;
                -ms-flex-pack: center;
                justify-content: center;
                flex-wrap: nowrap;

                .icon {
                    margin-right: 8px;
                }
                .text-icon {
                    margin: 0;
                }
            }
        }
    }
}
</style>